<template>
    <div>
        <!-- Modal Selecionar Leito -->
        <div class="modal fade" id="selecionarLeitoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Selecionar Leito</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="edicao_leito">
                        <div class="alert alert-info d-flex justify-content-between">
                            <div>
                                {{ edicao_leito.paciente.st_nome }}
                            </div>
                            <div>
                                #{{ edicao_leito.id_internacao }}
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input 
                                    sizing="sm"
                                    placeholder="Selecione o leito do paciente..."
                                    type="autocomplete" 
                                    optionsMode="aql"
                                    service="locals.index"
                                    optionsName="locals.index.leitos"
                                    :optionsSync="true"
                                    required
                                    label="Leito"
                                    v-model="edicao_leito.local"
                                    :validate="validate"
                                    :optionsParm="{ 
                                        ativos: true,
                                        leitos: true, 
                                        leitos_livres: true, 
                                        mapa_sala: true, 
                                    }" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return { 
            edicao_leito: null, 
            validate: false, 
        }
    },

    components: { 
        AzSubmit,
        AzInput,    
    },

    methods: { 
        abrir (internacao) { 
            this.edicao_leito = null; 
            this.validate = false; 

            this.$nextTick(() => { 
                this.edicao_leito = _.cloneDeep(internacao); 
                this.edicao_leito.local = null; 

                $('#selecionarLeitoModal').modal('show'); 
            }); 
        },

        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'internados', 
                func: 'selecionar_leito',
                dados: { 
                    id_internacao: this.edicao_leito.id_internacao,
                    id_local: this.edicao_leito.local.id_local,
                }, 
                modal: 'selecionarLeitoModal',
                toast: true, 
                callback: () => { 
                    this.$emit('refresh'); 
                }
            });
        }
    }
}
</script>
